<div *ngIf='userSessionData' class='AuthenticatedLayout d-flex flex-column' id='AuthenticatedLayout'>
  <div>
    <app-authenticated-header></app-authenticated-header>
  </div>
  <div class='AuthenticatedLayout-wrapper d-flex flex-row'>
    <div class='AuthenticatedLayout-leftMenu'>
      <app-left-menu></app-left-menu>
      <div *ngIf='billingNavigationBlocked' class='AuthenticatedLayout-leftMenuOverlay mt-3'>
      </div>
    </div>
    <div class='AuthenticatedLayout-container' [class.expanded]="!leftMenuExpanded">
      <div class='AuthenticatedLayout-container-alerts container pt-3'>
        <div
          *ngIf='showAlert && alertMessage'
          class='alert alert-danger alert-dismissible fade show'
          role='alert'>
          {{ alertMessage }}
          <button
            aria-label='Close'
            class='btn-close'
            data-bs-dismiss='alert'
            type='button'></button>
        </div>
      </div>
      <div>
        <div class='flex-grow-1'>
          <div class='AuthenticatedLayout-container-page container-fluid' id='AuthenticatedLayoutContainer'>
            <div *ngIf='userSessionData && (userSessionData.campaigns_suspended || userSessionData.emails_suspended)'
                 class='alert alert-danger'>
              <p *ngIf='userSessionData.campaigns_suspended' class='m-0 text-center'>Your campaigns are suspended. To
                resume sending campaign messages, please
                contact
                administrator</p>
              <p *ngIf='userSessionData.emails_suspended' class='m-0 text-center'>Your emails are suspended. To resume
                sending emails, please contact administrator</p>
            </div>
            <div *ngIf="contactGroupAlertSections.length" class="alert alert-warning contact-group-alert" role="alert">
              <div class="contact-group-alert-summary">
                <p class="m-0">Contact groups on this account need attention.</p>
                <button
                  type="button"
                  class="contact-group-alert-toggle"
                  [attr.aria-expanded]="contactGroupAlertExpanded"
                  aria-controls="contactGroupAlertDetails"
                  (click)="toggleContactGroupAlert()">
                  {{ contactGroupAlertExpanded ? 'Hide details' : 'Show details' }}
                </button>
              </div>
              <div *ngIf="contactGroupAlertExpanded" id="contactGroupAlertDetails">
                <p *ngFor="let section of contactGroupAlertSections" class="mb-0 mt-2">
                  <strong>{{ section.label }}:</strong> {{ section.detail }}
                </p>
              </div>
              <p class="mb-0 mt-2">
                <a routerLink="/user_contacts/user_groups" class="alert-link">Review contact groups</a>
              </p>
            </div>
            <div
              *ngIf="userSessionData?.billing_status === 'Awaiting card' && !billingGraceWarningDismissed"
              class='alert alert-warning alert-dismissible fade show'
              role='alert'>
              <p class='m-0'>
                Billing Alert: We either do not have a payment on file or your payment on record is failing.
                Please
                <a routerLink='/accounts/update_credit_card' class='alert-link'>update your billing info</a>
                before your grace period ends to maintain uninterrupted access. Thank you!
              </p>
              <button
                aria-label='Close'
                class='btn-close'
                type='button'
                (click)='dismissBillingGraceWarning()'></button>
            </div>
            <router-outlet></router-outlet>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-authenticated-footer></app-authenticated-footer>
</div>
